<template lang="html">
  <div style="flex-grow: 1; display: flex; min-width:440px;">
    <div class="head-filter">
      <FilterBar
          :establishments="establishments"
          :establishment="establishment"
          :sentiments="sentiments"
          :sentiment="sentiment"
          :platforms="platforms"
          :platform="platform"
          :status_set="status_set"
          :status="status"
          :tag_set="tag_set"
          :tag="tag"
          :dateBegin="dateBegin"
          :dateEnd="dateEnd"
          :pourcentageStatTagValue="pourcentageStatTagValue"
          :padAndLogos="true"
          :showConsultant="false"
          @update:establishment="establishmentClicked"
          @update:sentiment="sentimentClicked"
          @update:platform="platformClicked"
          @update:status="stateClicked"
          @update:tag="tagClicked"
          @update:dateBegin="dateBeginClicked"
          @update:dateEnd="dateEndClicked"
          @update:classified="classifiedClicked"
          @previousEstablishment="previousEstablishment"
          @nextEstablishment="nextEstablishment"
      />
    </div>
    <StatsTeam :consultant_uid="$store.state.profile.data.uid"
               v-if="$store.state.stats"></StatsTeam>
    <ReviewList :filters="filters"
                :consultant_uid="$store.state.profile.data.uid">
    </ReviewList>
  </div>
</template>

<script>
import ReviewList from '@/components/ReviewList'
import DropDown from '@/components/DropDown.vue'
import DropDownSearch from '@/components/ui/DropDownSearch.vue'
import StatsTeam from '@/components/StatsTeam.vue'
import PourcentageStatTag from '@/components/PourcentageStatTag.vue'
import utils from '@/utils.js'
import gql from '@/gqlService.coffee'
import queries from "@/gql/queries.coffee"
import FilterBar from "@/components/filter/FilterBar.vue";

const header_height = 170;

export default {
  name: "ReviewListFilterFlow",
  components: {
    FilterBar,
    ReviewList,
    DropDown,
    DropDownSearch,
    PourcentageStatTag,
    StatsTeam
  },
  props: {},
  computed: {
    style() {
      return {
        height: this.height
      };
    },
    pourcentageStatTagValue() {
      let ret = 0;
      if (this.$store.state.stats) {
        const sum = this.$store.state.stats.reduce((acc, current) => {
          if (current.consultant_id === this.$store.state.profile.data.uid) {
            acc.total += current['from_this_morning_count'];
            acc.total -= current['from_this_morning_impossible'];
            acc.validated += current['from_this_morning_validated_count'];
          }
          return acc;
        }, {total: 0, validated: 0});

        if (sum.total !== 0) {
          ret = Math.round(100 * sum.validated / sum.total);
        }
      }
      return ret;
    }
  },
  data() {
    return {
      showPad: false,
      tag_set: [
        {name: 'Supprimé', code: 'deleted'},
        {name: 'Répondu', code: 'answered'},
        {name: 'Impossible', code: 'Impossible'}
      ],
      height: (window.innerHeight - 30) + "px",
      listHeight: (window.innerHeight - header_height) + "px",
      filters: {
        tag: {name: null, code: null},
        dateBegin: null,
        dateEnd: null,
        search_string: "",
        classified: false,
        establishment: {name: null, uid: null},
        sentiment: {name: null, value: null},
        platform: {name: null, uid: null},
        status: {name: null, uid: null}
      },
      establishments: null,
      establishment: {name: null},
      sentiments: [
        {name: "Positif", value: true},
        {name: "Négatif", value: false}
      ],
      sentiment: {name: null, value: null},
      platforms: null,
      platform: {name: null},
      status_set: null,
      status: {name: null},
      dateBegin: null,
      dateEnd: null,
      tag: {name: null, code: null}
    };
  },
  methods: {
    dateEndClicked(item) {
      this.filters.dateEnd = this.dateEnd === "" ? null : this.dateEnd;
    },
    dateBeginClicked(item) {
      this.filters.dateBegin = this.dateBegin === "" ? null : this.dateBegin;
    },
    statusClicked(item) {
      this.status = item || {name: null, value: null};
      this.filters.classified = this.status.value === "Classified";
      this.filters.status = this.status;
    },
    tagClicked(item) {
      this.tag = item || {name: null, code: null};
      this.filters.tag = this.tag;
    },
    sentimentClicked(item) {
      this.sentiment = item || {name: null, value: null};
      this.filters.sentiment = this.sentiment;
    },
    establishmentClicked(item) {
      this.establishment = item || {name: null, uid: null};
      this.filters.establishment = this.establishment;
    },
    platformClicked(item) {
      this.platform = item || {name: null, uid: null};
      this.filters.platform = this.platform;
    },
    setHeight: utils.debounce(function () {
      this.height = (window.innerHeight - 30) + "px";
      this.listHeight = (window.innerHeight - header_height) + "px";
    }, 500),
    previousEstablishment() {
      const currentIndex = this.establishments.indexOf(this.establishment);
      if (currentIndex > 0) {
        this.establishment = this.establishments[currentIndex - 1];
      } else {
        this.establishment = this.establishments[this.establishments.length - 1];
      }
    },
    nextEstablishment() {
      const currentIndex = this.establishments.indexOf(this.establishment);
      if (currentIndex < this.establishments.length - 1) {
        this.establishment = this.establishments[currentIndex + 1];
      } else {
        this.establishment = this.establishments[0];
      }
    },
    clickPadButton() {
      this.showPad = !this.showPad;
      this.$emit("toggle-pad", this.showPad);
      this.$emit("select-page", 'pad');
    },
    clickLogosButton() {
      this.showPad = !this.showPad;
      this.$emit("toggle-pad", this.showPad);
      this.$emit("select-page", 'logos');
    }
  },
  async mounted() {
    this.setHeight();
    window.addEventListener('resize', this.setHeight);

    this.establishments = await gql.query({
      model: 'establishment_set',
      filters: `consultant__uid:"${String(this.$store.state.profile.data.uid)}"`,
      fields: "uid name"
    });

    this.platforms = await gql.query({
      model: 'platform_set',
      fields: "uid name"
    });

    const data = await queries.run("named_state_set");
    this.status_set = data.body.data.named_state_set;

    this.$djangows['onmodelsignals']({modelName: "review", appLabel: "review"}, async (event) => {
      const response = await queries.run('get_consultants_stats_from_view', []);
      this.$store.commit('set_stats', response.body.data.get_consultants_stats_from_view);
    });
  },
  watch: {
    "$store.state.selected_review_uid"() {
      return;
    }
  }
};
</script>


<style lang="scss" scoped>
.drop {
  width: 33%;
}

.pad {
  padding-top: 0px;
}

.head-filter {
  background-color: #fff;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  padding-top: 1.5em !important;
  padding-left: 70px;;
  padding-bottom: 0.7em !important;
  width: 100%;
  min-width: 1420px;
}

.clear-date {
  font-size: 12px;
  color: black;
  position: absolute;
  right: 20px;
  top: 8px;
  cursor: pointer;
}

.btn-showpad {

}
</style>
